import { useMemo, useState } from 'react';

export const useHovered = () => {
  const [isHovered, setIsHovered] = useState(false);

  const callbacks = useMemo(
    () => ({
      hoveredCallbacks: {
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
      },
    }),
    [],
  );

  return Object.assign(callbacks, { isHovered });
};
